import { action } from 'typesafe-actions';
import {
	ACLResource,
	ACLResourceType,
	IResourcesManagementActionTypes,
} from './Types';

export const addACLResource = (
	token: string,
	name: string,
	type: number,
	isparent: boolean,
	parentID?: number
) =>
	action(IResourcesManagementActionTypes.ADD_ACL_RESOURCE, [
		token,
		name,
		type,
		isparent,
		parentID,
	]);
export const addResourceFailed = (err: string) =>
	action(IResourcesManagementActionTypes.ADD_ACL_RESOURCE_FAILED, err);
export const addResourceSucceed = () => {
	return action(IResourcesManagementActionTypes.ADD_ACL_RESOURCE_SUCCEED);
};

export const deleteACLResource = (token: string, id: number) =>
	action(IResourcesManagementActionTypes.DELETE_ACL_RESOURCE, [token, id]);

export const deleteACLResourceSucceed = (id: number) => 
	action(IResourcesManagementActionTypes.DELETE_ACL_RESOURCE_SUCCEED, { id });

export const deleteACLResourceFailed = (error: string) => {
	return action(IResourcesManagementActionTypes.DELETE_ACL_RESOURCE_FAILED, error);
};

export const getACLResource = (token: string, id: number) =>
	action(IResourcesManagementActionTypes.GET_ACL_RESOURCE, [token, id]);
export const getACLResourceFailed = (err: string) =>
	action(IResourcesManagementActionTypes.GET_ACL_RESOURCE_FAILED, err);
export const getACLResourceSucceed = (data: ACLResource) =>
	action(IResourcesManagementActionTypes.GET_ACL_RESOURCE_SUCCEED, data);

export const getACLResources = (token: string) =>
	action(IResourcesManagementActionTypes.GET_ACL_RESOURCES, [token]);
export const getACLResourcesFailed = (err: string) =>
	action(IResourcesManagementActionTypes.GET_ACL_RESOURCES_FAILED, err);
export const getACLResourcesSucceed = (data: ACLResource[]) =>
	action(IResourcesManagementActionTypes.GET_ACL_RESOURCES_SUCCEED, data);

export const getACLResourcesParents = (token: string) =>
	action(IResourcesManagementActionTypes.GET_ACL_RESOURCESPARENTS, [token]);
export const getACLResourcesParentsFailed = (err: string) =>
	action(
		IResourcesManagementActionTypes.GET_ACL_RESOURCESPARENTS_FAILED,
		err
	);
export const getACLResourcesParentsSucceed = (data: ACLResource[]) =>
	action(
		IResourcesManagementActionTypes.GET_ACL_RESOURCESPARENTS_SUCCEED,
		data
	);

export const getACLResourcesTypes = (token: string) =>
	action(IResourcesManagementActionTypes.GET_ACL_RESOURCESTYPES, [token]);
export const getACLResourcesTypesFailed = (err: string) =>
	action(IResourcesManagementActionTypes.GET_ACL_RESOURCESTYPES_FAILED, err);
export const getACLResourcesTypesSucceed = (data: ACLResourceType[]) =>
	action(
		IResourcesManagementActionTypes.GET_ACL_RESOURCESTYPES_SUCCEED,
		data
	);

export const updateACLResource = (
	token: string,
	id: number,
	resource: ACLResource
) =>
	action(IResourcesManagementActionTypes.UPDATE_ACL_RESOURCE, [
		token,
		id,
		resource,
	]);
export const updateACLResourceFailed = (err: string) =>
	action(IResourcesManagementActionTypes.UPDATE_ACL_RESOURCE, err);
export const updateACLResourceSucceed = (resource: ACLResource) => 
	action(IResourcesManagementActionTypes.UPDATE_ACL_RESOURCE_SUCCEED, { resource });

export const emptyListACLResources = () =>
	action(IResourcesManagementActionTypes.EMPTY_LIST_ACL_RESOURCES);

export const setLoadingACLResources = (bool: boolean) =>
	action(IResourcesManagementActionTypes.SET_LOADING_ACLRESOURCES, bool);

export const setCreatingResource = (isLoading: boolean) =>
	action(IResourcesManagementActionTypes.SET_CREATING_RESOURCE, { isLoading });
